/* eslint-disable no-undef */

import { logDebugging } from '../log/logger';

/**
 * returns an object with query params of the url
 * if there is no params, returns null
 * @param {String} url
 * @returns object or null
 */
function setParametersToUrl(baseUrl, params) {
  let connector = !baseUrl.includes('?') ? '?' : '';
  let url = baseUrl;
  Object.entries(params).forEach((param, i) => {
    connector = i === 0 ? connector : '&';
    url += `${connector}${param[0]}=${param[1]}`;
  });
  return url;
}
function getParametersFromUrl(url) {
  // eslint-disable-next-line no-undef
  const query = typeof url === 'undefined' ? window.location.search.substring(1) : url;
  const aux = query.split('?');
  const paramsString = aux.length > 0 ? aux.slice(1, aux.length).join() : null;
  try {
    if (paramsString) {
      return JSON.parse(
        `{"${decodeURIComponent(paramsString.replace(/&/g, '","').replace(/=/g, '":"'))}"}`,
      );
    }
  } catch (error) {
    logDebugging('Params from url not get');
  }

  return null;
}

function getParentUlrOrigin() {
  const locationAreDisctint = window.location !== window.parent.location;
  const parentOrigin = (
    (locationAreDisctint ? document.referrer : document.location) || ''
  ).toString();

  if (parentOrigin) {
    return parentOrigin;
  }

  const currentLocation = document.location;

  if (currentLocation.ancestorOrigins && currentLocation.ancestorOrigins.length) {
    return currentLocation.ancestorOrigins[0];
  }

  return '';
}

function getHostName(url) {
  if (url) {
    return new URL(url).hostname;
  }
  return false;
}

export default {
  getParametersFromUrl,
  getParentUlrOrigin,
  getHostName,
  setParametersToUrl,
};
